import logger from './logger'

const configFactory = (config, env = process.env.NODE_ENV) => {
  let result;

  if (config[env] !== undefined) {
    result = config[env];
  } else if (config.development) {
    logger.warn({
      label: 'configFactory',
      message: `We couldn't find a config for the ENV ${env}. Using DEV's config as the default.`,
    });

    result = config.development;
  } else {
    logger.warn({
      label: 'configFactory',
      message: `We couldn't find a config for the ENV ${env}. Returning the entire config object.`,
    });

    result = config;
  }

  logger.info(result);
  return result;
};

export { configFactory };
